import StandardSetSheet from '@/components/paperwork/StandardSetSheet.jsx';

// "Send the standard set" (paperwork-1 A5, L3-2). This was the "Publish documents" dialog (Gap 3: a checklist of the deal's
// publishable documents, published to the OTP-gated client portal with one email and text). A5 retires publishing as a send
// path: the standard set sends the files themselves, attached, to every recipient (the client, each loss payee, lienholder
// and additional insured), and the portal keeps serving what was already published, unchanged (its reader and the server's
// publish door are not touched). The deal actions menu ("send_bundle") still opens this dialog; it now opens the standard
// set's sheet. Rework accounting: docs/paperwork-1/REWORK-L3.md.
export default function SendBundleDialog({ open, onOpenChange, dealId, onChange }) {
  if (!open) return null;
  return <StandardSetSheet dealId={dealId} open={open} onOpenChange={onOpenChange} onSent={() => { if (typeof onChange === 'function') onChange(); }} />;
}
